import { PHONE, locationSchema } from "../structured-data-core";

export function getChicagoStructuredData() {
  const url = "https://restorehair.com/locations/restore-chicago/";
  const description =
    "Restore your confidence with the top hair restoration team serving Chicago and the surrounding suburbs. Over 20,000 procedures.";
  return [
    locationSchema("Chicago – Fulton Market", "159 N Sangamon St, Suite 200", "Chicago", "IL", PHONE, url, description),
    locationSchema("Chicago – Hancock Center", "875 North Michigan Avenue, 31st Floor", "Chicago", "IL", PHONE, url, description),
    locationSchema("Chicago Lincoln Park", "939 W. North Avenue, Suite 750", "Chicago", "IL", PHONE, url, description),
    locationSchema("Lake Forest", "100 S. Saunders Rd, Suite 150", "Lake Forest", "IL", PHONE, url, description),
    locationSchema("Oak Brook", "1415 22nd St, #950", "Oak Brook", "IL", PHONE, url, description),
    locationSchema("Schaumburg", "10 N. Martingale Rd, Suite 400", "Schaumburg", "IL", PHONE, url, description),
  ];
}
